export default {
  content: `아이투맥스 메시징 서비스 이용 약관

(주)아이투맥스(www.i2max.co.kr 이하 "회사" 또는 "i2message"이라 함)는 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 준수해야 할 관련 법령상의 개인정보보호규정을 준수하며, 관련 법령에 의거한 개인정보 처리 및 보호정책을 정하여 회원 권익 보호에 최선을 다하고 있습니다. 본 개인정보 처리 및 보호정책은 "i2message" 서비스 약관의 일부를 구성하며(자세한 내용은 이용약관 에서 확인하실 수 있습니다) "i2message" 서비스 약관에 따라 변경될 수 있습니다. 이용자는 서비스 약관 및 개인정보 처리 및 보호정책에 따라 서비스를 이용하고 "i2message" 서비스에 개인정보를 제공합니다. 
1. 개인정보 수집 항목 및 수집 방법
(1) 개인정보 수집 항목

가. 회사는 회원가입 및 각종 서비스의 제공을 위해 최초 회원가입 당시 아래와 같은 개인정보를 수집하고 있습니다.
- 필수항목: 성명(법인명), 대표자명, 사업자등록번호, 업종/업태, 담당자명, 유선전화 번호, 이동전화 번호, 이메일주소, 주소

나. 서비스 이용 과정에서 아래와 같은 정보들이 자동으로 생성 및 수집될 수 있습니다.
- IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록 

(2) 개인정보 수집 방법
회사는 다음과 같은 방법으로 개인정보를 수집합니다.
- 인터넷 및 휴대형 단말기의 서비스, 홈페이지, 서면양식, 팩스, 전화, 1:1문의게시판, 이메일

2. 개인정보의 수집 및 이용목적 
(1) 회원관리
- 회원제 서비스 이용, 개인식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입의사 확인, 가입 및 가입횟수 제한, 분쟁 조정을 위한 기록 보존, 불만처리 등 민원처리, 고지사항 전달 
- 회사는 회원이 공개적으로 등록한 정보 이외에 회원 개인의 신상에 관한 정보를 제3자에게 제공하지는 아니합니다. 

(2) 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산
청구서 발송, 본인인증, 구매 및 요금 결제, 요금 추심

(3) 신규 서비스 개발 및 마케팅·광고·홍보에의 활용 
신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여 기회 제공, 접속 빈도 파악, 회원의 서비스 이용에 대한 통계 
회사는 회원의 개인 정보를 상업적인 마케팅 또는 광고 또는 홍보에 사용하지 않으나, 회원의 동의, 또는 회원이 참여 의사를 표명, 또는 선택한 서비스의 기능 실행으로 인하여 제공되는 경우에는 예외로 합니다. 또한 회사는 회원의 추가적인 동의가 없어도 광고와 무관한 목적 또는 운영상의 목적으로는 회원의 이메일 주소, 또는 전화번호, 또는 개인 신상에 관한 정보를 사용할 수 있습니다.
회사는 회원의 서비스 선호도 또는 사용 경향에 관한 정보를 축적 및 분석하여 “i2message” 서비스의 품질, UI 및 디자인 등을 개선 또는 서비스의 새로운 기능을 개발하기 위한 목적으로 회원의 개인 신상정보 또는 신상과 관련되지 아니한 정보 모두를 사용할 수 있습니다.
회사는 정보를 저장함으로써 회원이 다시 서비스에 접속할 때 매번 정보를 입력하지 아니하여도 접속이 가능하도록 하기 위하여, 또는 이용자 개인에 맞춘 정보 또는 콘텐츠를 제공하기 위하여, 또는 서비스의 방문자 수, 페이지뷰 횟수 등을 확인하기 위하여, 또는 이용자의 서비스 이용 정도, 글수, 전송건수, 방문수, 사진/동영상 업로드 개수 등을 확인하기 위하여 쿠키와 로그파일을 정보로 사용할 수 있습니다.

3. 개인정보의 제3자 제공에 관한 사항
(1) 회사는 회원의 개인정보를 "2. 개인정보의 수집목적 및 이용목적 "에서 고지한 범위 내에서 사용하며, 회원의 사전 동의 없이는 본 개인정보 처리 및 보호정책의 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.
- 고객으로부터 사전에 개인정보를 목적 외의 용도로 제공하는 것에 대한 동의를 받은 경우
- 법령에 특별한 규정이 있거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
- 통계작성, 학술연구, 시장조사 등을 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
- 회사가 법령상 의무를 준수하기 위하여 불가피하게 수집한 개인정보를 그 수집 목적 범위 내에서 제공하는 경우

(2) 회사는 서비스 약관을 이행하기 위하여, 또는 회사의 책임이 예상되는 사항을 방지하기 위한 예방조치를 취하기 위하여, 또는 소송에 대응 또는 정부 시책의 이행을 위하여, 또는 서비스의 안전성과 보안을 유지 또는 회사와 회사 관련자들의 안전과 권리 및 재산을 보호하기 위하여, 또는 다른 회원의 권익을 보호하기 위하여, 합리적인 판단에 따라 회원의 신상 관련 정보 또는 신상과 관련 없는 정보를 공개할 수 있습니다. 

(3) 회사는 회원의 개인 신상 관련 정보를 제3자의 상업적인 목적으로 제공하지 않으나, 회원의 동의가 있거나 회원이 참여 여부를 결정 또는 선택한 서비스의 기능을 실행한 결과로서 제공되는 경우에는 정보를 제공할 수 있습니다.

(4) 회사는 “i2message” 서비스 상의 특정 메뉴, 콘텐츠, 광고, 홍보, 기능 등의 사용형태와 관련하여 “i2message” 서비스에 관심을 가지는 제3자의 이해 도모를 위하여 회원의 신상과 관련 없는 정보를 제공할 수 있습니다.

(5) 회사는 광고를 원하는 법인 및 개인 사업자가 “i2message” 서비스를 이용하여 광고하는 것을 허용할 수 있습니다. 광고를 원하는 법인 및 개인 사업자가 직접 회원의 브라우저 또는 “i2message” 서비스에 광고 관련 내용 또는 링크 페이지를 전송하는 방법을 사용하게 되는 경우 광고를 원하는 법인 및 개인 사업자가 회원의 IP 주소 정보를 받을 수 있습니다. 광고를 원하는 법인 및 개인 사업자가 광고 효과를 측정하고 보다 효율적인 광고 콘텐츠를 개발하기 위하여 쿠키, 자바스크립트 등과 같은 기술도 사용할 수 있습니다. 회사는 회원의 동의가 있거나 회원이 참여 의사를 표명했거나 선택한 서비스의 기능을 실행함으로 인하여 제공되는 경우를 제외하고는, 광고를 원하는 법인 및 개인 사업자에게 개인 신상에 관한 정보를 제공하지 않습니다. 그러나 광고를 원하는 법인 및 개인 사업자가 회사에게 광고를 “특정한 회원(들) 또는 회원 그룹”에게 보여줄 것을 요청하고, 이에 반응하는 회원이 있는 경우에는 당해 회원이 광고를 원하는 법인 및 개인 사업자가 요청한 “특정한 회원(들) 또는 회원 그룹”에 해당하는 것으로 간주하고 그러한 회원들의 서비스 사용패턴에 관한 정보를 이용할 수 있습니다.

4. 개인정보 처리의 위탁에 관한 사항
회사는 서비스 이행을 위해 이용자의 개인정보를 위탁 처리할 경우 위탁하는 내용 및 수탁자를 고지하고, 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정해 관련 법규를 준수하고 이를 감독합니다. 회사의 개인정보 위탁처리 기관 및 위탁업무 내용은 다음과 같습니다.`,
  table: [
    '수탁업체',
    '위탁업무 내용',
    '개인정보 보유 및 이용기간',
    '한국모바일인증㈜',
    '휴대폰 본인 인증',
    '(발신번호 등록 업무 용도)',
    '해당 업체에서 보유하고 있는 개인정보',
    '(별도로 저장하지 않음)',
    'NHN Cloud',
    '메시지, 알림톡, 친구톡 발송',
    '위탁 계약 종료 시',
    '인포뱅크',
    '메시지, 알림톡, 친구톡 발송',
    '위탁 계약 종료 시',
  ],
  content2: `5. 개인정보의 보유 및 이용기간 
회사는 이용자의 개인정보를 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.
(1) 회사 내부 방침에 의한 정보보유 사유 
가. 부정이용기록 
- 보존 이유: 부정 이용 방지 
- 보존 기간: 1년

(2) 관련법령에 의한 정보 보유 사유
상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.`,
  table2: [
    '보존 근거',
    '보존 내용',
    '보존기간',
    `전자상거래 등에서
    소비자보호에 관한 법률`,
    '계약 또는 청약철회 등에 관한 기록',
    '5년',
    '대금 결제 및 재화 등의 공급에 관한 기록',
    '5년',
    '소비자 불만 또는 분쟁 처리에 관한 기록',
    '3년',
    '통신비밀보호법',
    '웹사이트 방문에 관한 기록',
    '3개월',
    '핸드폰번호, 문자 전문 등을 포함한 통신이력',
    '3개월',
    '문자전문을 제외한 핸드폰 번호등을 포함한 통신이력',
    '(시외/시내전화역무와 관련된 자료)',
    '6개월',
  ],
  content3: `(3) 장기 미 이용 회사의 개인정보 분리 보관(휴면 회원)
장기 미 이용 회사(“이용고객”의 서비스 이용 상태가 계약해지, 고객중지 및 해지 요청 상태인 회사)는 요금 미납 없이 서비스 상태 변경일로부터 5년이 지난 회사를 말합니다. 이 회사의 수집된 개인정보는 별도로 분리되어 안전하게 보관됩니다. 
장기 미 이용 회사가 별도 DB로 분리 전에 지속적으로 ㈜아이투맥스의 메시지 서비스를 이용하시고자 하는 경우, 담당자(i2maxadmin@i2max.co.kr)를 통해 연락 하시기를 요청 드립니다. 회사의 요청 시에는 기존의 계정을 재사용하실 수 있습니다.


6. 개인정보 파기절차 및 방법 
이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다. 
(1) 파기절차 
가. 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다.
나. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.
단, 상법 등 관련법령의 규정에 의하여 다음과 같이 거래 관련 권리 의무 관계의 확인 등을 이유로 일정기간 보유하여야 할 필요가 있을 경우에는 일정기간 보유합니다.

(2) 파기방법  
가. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
나. 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 영구 삭제합니다.

7. 이용자 및 법정대리인의 권리와 그 행사방법
이용자 및 법정 대리인은 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다. 이용자의 개인정보 조회를 위해서는 ‘회원정보’를, 가입해지(동의철회)를 위해서는 영업담당자와의 연락을 통해 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 
혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다. 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3 자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다. 회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "5. 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다. 

8. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
회사는 개인형 또는 맞춤형 서비스를 제공하기 위해서 회원의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 회원의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다.
(1) 쿠키 정보(방문기록 정보)
회원이 서비스를 방문 또는 이용하면 회사는 오직 회원의 브라우저를 확인하기 위하여 쿠키를 회원의 컴퓨터로 전송합니다. 임시 쿠키와 영구 쿠키 두 가지가 있고, 영구 쿠키는 회원이 브라우저를 종료한 이후에도 남아 있으며, 영구쿠키는 회원이 다음 번에 서비스를 방문하는 경우에 회원의 브라우저를 통하여 사용됩니다. 영구쿠키는 헬프 파일에 기재된 방식으로 제거되며, 회원은 모든 쿠키의 설치를 거부하고자 하는 경우 또는 쿠키가 전송되는 시점을 재지정하고자 하는 경우, 웹브라우저를 재설정할 수 있습니다. 단, 쿠키가 활성화되지 않으면 서비스의 기능이 작동하지 않을 수 있습니다.

(2) 로그 정보
회원이 서비스를 이용하는 경우 서버는 자동으로 회원의 웹브라우저가 서비스를 방문할 때 마다 전송하는 특정한 정보를 기록하게 됩니다. 회원이 서비스를 이용하면 서버는 회원이 게시물을 업데이트 하거나 요청할 때마다 회사의 프로그램이 전송하는 특정한 정보를 자동으로 기록하게 됩니다. 위 서버로그는 이용자의 웹 상의 요청, 인터넷프로토콜, 브라우저 유형, URL, 플랫폼 유형, 도메인 명칭, 페이지 관련 정보, 회원의 요청 시각을 포함합니다.

9. 개인정보의 기술적∙관리적 보호 대책
회사는 회원의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.

(1) 기술적 대책
개인정보 암호화
이용자의 비밀번호, 휴대폰 번호 등과 같은 중요 정보는 암호화되어 저장 및 관리되고 있습니다.

해킹 등에 대비한 대책 
회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.

개인정보에 대한 접근제한
개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근을 통제하고, 침입차단시스템과 침입방지시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.

(2) 관리적 대책
취급 직원의 최소화 및 교육
회사의 개인정보관련 취급 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 회사의 개인정보처리방침의 준수를 항상 강조하고 있습니다.

개인정보보호전담기구의 운영
사내 개인정보보호전담기구 등을 통하여 회사의 개인정보취급방침의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다. 단, 이용자 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호 등 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.

데이터 보안 
회사는 회원 정보의 보호를 위하여 필요한 관리∙처리 및 기술상의 안전 장치를 사용합니다. 그러나 회사는 회원이 회사에 제공하는 정보의 안전을 보장하지는 못하며 회원은 회원의 위험 부담 하에 정보를 제공하여야 합니다. 일단 회원의 정보를 제공받은 회사는 서비스 시스템의 안전성을 확보하기 위한 합리적인 노력을 다합니다. 
만약 회사가 안전장치의 침해 사실을 알게 되면 회사는 회원에게 전자적인 방법으로 침해 사실을 알리고, 회원이 회원의 정보를 보호하기 위한 적절한 조치를 취할 수 있도록 할 것입니다. 회사는 만일 안전장치의 침해 사실이 발생하게 되면 서비스에 공지사항을 게시할 것입니다.

10. 해외 회원들에 대한 고지
회사의 “i2message” 서비스는 대한민국을 기반으로 하여, 대한민국에 거주하는 회원을 서비스의 직접적인 대상으로 하고 있습니다. 개인정보의 수집, 이용 및 공개와 관련하여 대한민국의 법령이 적용되지 아니하는 국가의 회원, 또는 대한민국 법령과 다른 법령의 적용을 받는 국가의 회원은 “i2message” 서비스 이용으로 인하여 회원의 개인정보가 대한민국에 위치한 회사로 전송된다는 것을 인식하고 있으며 이러한 전송에 동의하는 것으로 간주됨을 인지하여야 합니다.

11. 개인정보 보호책임자 및 담당자의 연락처
귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
(1) 개인정보 보호책임자 
- 이름: 박철용 
- 소속: 경영지원본부 
- 직위: 부사장
- 전화: 02-365-2187

(2) 개인정보 보호 담당부서 
- 이름: 김동한 
- 소속: 마케팅팀
- 직위: 이사
- 전화: 031-070-7705-7215

(3) 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
- 개인정보침해신고센터 (privacy.kisa.or.kr / (국번없이) 118) 
- 대검찰청 사이버수사과 (www.spo.go.kr / (국번없이) 1301)
- 경찰청 사이버안전국 (cyberbureau.police.go.kr / (국번없이) 182)

12. 기타
“i2message” 서비스에 링크되어 있는 유무선 사이트들이 개인정보를 수집하는 행위에 대해서는 본 “개인정보처리 및 보호정책”이 적용되지 않음을 알려 드립니다.

13. 개인정보 처리 및 보호정책의 변경과 고지의 의무
현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 서비스의 '공지사항'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.
개인정보의 이용 및 보호정책은 정기적으로 변경될 수 있습니다. 회원은 “i2message” 서비스 홈페이지를 방문하여 개인정보 처리 및 보호정책의 변경을 확인하여 주시기 바랍니다. 회원이 계속적으로 서비스를 이용하는 경우 이는 회원이 현재의 개인정보 처리 및 보호정책뿐 아니라 미래의 변경사항에 대해서도 동의하는 것으로 간주됩니다.`,
};
